// import PlatformType from "enums/platform-type";

export const initialFilterState = () => ({
  startDate: null,
  endDate: null,
  convertFrom: "",
  convertTo: "",
});
